var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentrifugeTopEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 325,
    fill: "none",
    viewBox: "0 0 184 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M1 233h182l-7.478 76.903c-.315 3.247-2.555 5.96-5.728 6.719C158.642 319.291 130.312 325 92 325s-66.642-5.709-77.794-8.378c-3.173-.759-5.413-3.472-5.729-6.719L1 233z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M91.6 317.503c50.589 0 91.6-41.011 91.6-91.6 0-50.589-41.011-91.6-91.6-91.6-50.59 0-91.6 41.011-91.6 91.6 0 50.589 41.01 91.6 91.6 91.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M91.6 317.503c50.589 0 91.6-41.011 91.6-91.6 0-50.589-41.011-91.6-91.6-91.6-41.957 0-77.326 28.21-88.174 66.697A91.669 91.669 0 0 0 0 225.903c0 50.589 41.01 91.6 91.6 91.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M91.6 304.103c43.189 0 78.2-35.011 78.2-78.2s-35.011-78.2-78.2-78.2-78.2 35.011-78.2 78.2 35.011 78.2 78.2 78.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M91.6 299.703c40.759 0 73.8-33.041 73.8-73.8s-33.041-73.8-73.8-73.8-73.8 33.041-73.8 73.8 33.041 73.8 73.8 73.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M91.6 29.662c-41.8 0-75.7 26.493-75.7 59.22 0 32.727 33.9 59.221 75.7 59.221 41.8 0 75.7-26.494 75.7-59.22 0-32.728-33.9-59.221-75.7-59.221zm0 78.013c-13.2 0-24-8.434-24-18.701 0-10.267 10.7-18.701 24-18.701 13.2 0 24 8.434 24 18.7 0 10.268-10.7 18.702-24 18.702z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M91.6 33.42c-39.2 0-70.9 24.844-70.9 55.462 0 30.619 31.8 55.462 70.9 55.462 39.2 0 70.9-24.843 70.9-55.462 0-30.618-31.7-55.462-70.9-55.462zm0 76.089c-14.5 0-26.3-9.259-26.3-20.627 0-11.367 11.8-20.626 26.3-20.626s26.3 9.259 26.3 20.626c0 11.368-11.7 20.627-26.3 20.627z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M115.6 88.882c0 5.042-2.6 9.626-6.8 13.018-3.7 3.025-8.7 5.042-14.3 5.592-.9.091-1.9.091-2.9.091-13.2 0-24-8.433-24-18.7 0-1.1.1-2.2.4-3.21 2 8.801 11.8 15.493 23.6 15.493.6 0 1.2 0 1.8-.091 5-.275 9.5-1.742 13.1-4.034 4.5-2.75 7.7-6.875 8.7-11.459.3 1.1.4 2.2.4 3.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.8 101.9c-3.7 3.025-8.7 5.042-14.3 5.592l-1.1-6.417c5-.275 9.5-1.742 13.1-4.034l2.3 4.859z",
    opacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M135 132.794l-18.9-36.302c-3.9 7.609-13.4 13.017-24.5 13.017-1.9 0-3.8-.183-5.6-.458l6 35.294c16.2-.092 31.1-4.401 43-11.551z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M115.6 20.036c-5.4-1.925-13.4-3.942-23-4.033-10.6-.092-19.2 2.108-24.9 4.033v14.301a78.624 78.624 0 0 1 24.4-3.667c9.8.092 17.9 1.925 23.6 3.667-.1-4.767-.1-9.534-.1-14.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M67.22 18.615c5.806-1.96 14.578-4.206 25.393-4.112h.001c9.8.093 17.966 2.151 23.49 4.12l.996.356v1.057c0 4.77 0 9.521.1 14.27l.043 2.071-1.981-.605c-5.601-1.712-13.555-3.512-23.176-3.602a77.128 77.128 0 0 0-23.934 3.597l-1.952.618V18.96l1.02-.345zm1.98 2.506v11.196a80.038 80.038 0 0 1 22.914-3.146 84.663 84.663 0 0 1 22.049 3.154 750.517 750.517 0 0 1-.063-11.221c-5.244-1.77-12.688-3.517-21.514-3.601-9.771-.085-17.81 1.819-23.386 3.618z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D0E0E",
    d: "M91.6 283.803c31.977 0 57.9-25.923 57.9-57.9s-25.923-57.9-57.9-57.9-57.9 25.923-57.9 57.9 25.923 57.9 57.9 57.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M91.6 247.303c11.819 0 21.4-9.581 21.4-21.4 0-11.819-9.581-21.4-21.4-21.4-11.819 0-21.4 9.581-21.4 21.4 0 11.819 9.581 21.4 21.4 21.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M55.997 195.114c-3.8-.6-7.8 1.2-9.8 4.7-2 3.6-1.4 7.9 1.1 10.8l2.6 2.1c4.6 2.5 10.3.9 12.9-3.7 2.5-4.6.9-10.3-3.7-12.9l-3.1-1z",
    opacity: 0.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M55.797 195.315c-3.6-.6-7.4 1.1-9.3 4.5-1.9 3.4-1.3 7.5 1.1 10.3l2.4 2c4.4 2.4 9.9.8 12.3-3.5 2.4-4.4.9-9.9-3.5-12.3l-3-1z",
    opacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M61.097 208.014c-1.7 3.1-5.1 4.7-8.5 4.2-.3 0-.6-.1-.9-.2-.4-.1-.8-.2-1.2-.4-.2-.1-.4-.2-.7-.3-4-2.2-5.5-7.3-3.2-11.3 2.2-4 7.3-5.5 11.3-3.2 1.1.6 2 1.4 2.7 2.4l.6.9c0 .1.1.2.1.2 1.1 2.3 1.2 5.2-.2 7.7z",
    opacity: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M61.097 208.014c-1.7 3.1-5.1 4.7-8.5 4.2-1.2-2.4-1.2-5.2.2-7.7 1.7-3.1 5.1-4.7 8.5-4.2 1.1 2.3 1.2 5.2-.2 7.7z",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M74.544 179.908c-3.481-1.638-7.825-1.027-10.723 1.775a9.488 9.488 0 0 0-1.96 10.677l1.909 2.743a9.523 9.523 0 0 0 13.42.051 9.522 9.522 0 0 0 .051-13.42l-2.697-1.826z",
    opacity: 0.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M74.296 180.044c-3.29-1.581-7.413-1.011-10.187 1.723-2.774 2.734-3.343 6.838-1.821 10.197l1.746 2.591c3.554 3.534 9.282 3.534 12.788.076 3.533-3.555 3.63-9.255.075-12.788l-2.601-1.799z",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M75.837 193.719c-2.498 2.501-6.21 3.088-9.335 1.658-.288-.084-.548-.264-.808-.443-.356-.208-.712-.416-1.04-.72a4.793 4.793 0 0 0-.589-.483c-3.226-3.23-3.242-8.546.084-11.744 3.23-3.227 8.546-3.242 11.744.084a7.809 7.809 0 0 1 1.922 3.058l.325 1.032c-.028.096.04.22.04.22.414 2.516-.3 5.328-2.343 7.338z",
    opacity: 0.7
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M75.837 193.719c-2.498 2.501-6.21 3.088-9.335 1.658-.482-2.64.3-5.328 2.343-7.338 2.499-2.501 6.21-3.088 9.335-1.658.414 2.516-.3 5.328-2.343 7.338z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M123.172 187.898c.043-3.847-2.318-7.544-6.07-9.016a9.49 9.49 0 0 0-10.527 2.653l-1.701 2.877a9.522 9.522 0 0 0 5.53 12.228 9.522 9.522 0 0 0 12.228-5.53l.54-3.212z",
    opacity: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M122.945 187.729c.072-3.649-2.161-7.162-5.8-8.55-3.64-1.387-7.61-.199-10.032 2.581l-1.631 2.665c-1.738 4.701.643 9.911 5.245 11.663 4.701 1.737 9.926-.544 11.663-5.246l.555-3.113z",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M111.147 194.813c-3.313-1.232-5.389-4.365-5.387-7.801-.044-.297.012-.608.067-.92.041-.41.082-.82.222-1.245.07-.212.14-.425.196-.736 1.597-4.277 6.425-6.5 10.717-4.804 4.276 1.597 6.499 6.426 4.803 10.717a7.806 7.806 0 0 1-1.983 3.02l-.804.724c-.099.014-.183.128-.183.128-2.116 1.421-4.971 1.94-7.648.917z",
    opacity: 0.7
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M111.147 194.813c-3.313-1.233-5.389-4.365-5.387-7.802 2.201-1.535 4.971-1.94 7.648-.917 3.313 1.232 5.389 4.365 5.387 7.801-2.116 1.422-4.971 1.941-7.648.918z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M142.017 218.721c3.111 2.263 4.667 6.364 3.606 10.253a9.488 9.488 0 0 1-8.414 6.859l-3.324-.354a9.522 9.522 0 0 1-6.505-11.738 9.522 9.522 0 0 1 11.738-6.505l2.899 1.485z",
    opacity: 0.7
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M141.946 218.933c2.97 2.121 4.455 6.01 3.394 9.758-1.061 3.748-4.384 6.223-8.061 6.506l-3.111-.283c-4.808-1.415-7.566-6.435-6.223-11.173 1.415-4.808 6.364-7.636 11.173-6.222l2.828 1.414z",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M129.289 224.236c-.99 3.394.283 6.93 3.041 8.981.212.212.495.353.777.495.354.212.707.424 1.132.565.212.071.424.142.707.283 4.384 1.273 9.051-1.273 10.253-5.728 1.273-4.384-1.273-9.05-5.728-10.253a7.817 7.817 0 0 0-3.606-.212l-1.061.212c-.07.071-.212.071-.212.071-2.475.778-4.525 2.829-5.303 5.586z",
    opacity: 0.7
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M129.289 224.236c-.99 3.394.283 6.93 3.041 8.98 2.545-.848 4.525-2.828 5.303-5.586.99-3.394-.283-6.929-3.041-8.98-2.474.778-4.525 2.828-5.303 5.586z",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M130.291 194.045c3.832.339 7.277 3.055 8.368 6.936a9.488 9.488 0 0 1-3.686 10.211l-3.031 1.407a9.522 9.522 0 0 1-11.618-6.718 9.522 9.522 0 0 1 6.717-11.618l3.25-.218z",
    opacity: 0.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M130.34 194.263c3.638.291 6.912 2.862 7.931 6.621 1.019 3.759-.557 7.591-3.565 9.726l-2.813 1.358c-4.851 1.262-9.799-1.624-11.084-6.378-1.262-4.85 1.527-9.822 6.378-11.084l3.153-.243z",
    opacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M122.215 205.323c.898 3.42 3.809 5.797 7.228 6.136.291.073.607.048.922.024.412 0 .825 0 1.261-.097.218-.049.437-.097.752-.121 4.414-1.165 7.106-5.749 5.845-10.187-1.165-4.414-5.749-7.106-10.187-5.845a7.825 7.825 0 0 0-3.202 1.674l-.8.728c-.024.097-.145.169-.145.169-1.722 1.941-2.426 4.754-1.674 7.519z",
    opacity: 0.7
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M122.216 205.323c.897 3.42 3.808 5.797 7.227 6.136 1.747-2.037 2.426-4.754 1.674-7.519-.898-3.419-3.809-5.796-7.228-6.135-1.722 1.94-2.426 4.753-1.673 7.518z",
    opacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M100 274.887c-1.8 3.4-5.6 5.5-9.7 5-4.1-.6-7.2-3.6-8-7.4l-.1-3.3c.7-5.2 5.5-8.8 10.7-8.1 5.2.7 8.8 5.5 8.1 10.7l-1 3.1z",
    opacity: 0.7
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M99.7 274.887c-1.7 3.3-5.3 5.3-9.2 4.7-3.9-.5-6.8-3.4-7.6-7l-.1-3.1c.7-4.9 5.2-8.4 10.2-7.7 4.9.7 8.4 5.2 7.7 10.2l-1 2.9z",
    opacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M92.7 263.087c-3.5-.5-6.8 1.3-8.4 4.3-.2.3-.3.6-.4.8-.2.4-.3.8-.4 1.2-.1.2-.1.5-.1.7-.6 4.6 2.6 8.7 7.1 9.3 4.5.6 8.7-2.6 9.3-7.1.2-1.2.1-2.5-.3-3.6-.1-.3-.2-.7-.4-1 0-.1-.1-.2-.1-.2-1.1-2.3-3.4-4-6.3-4.4z",
    opacity: 0.7
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M92.7 263.088c-3.5-.5-6.8 1.3-8.4 4.3 1.2 2.4 3.5 4.1 6.3 4.5 3.5.5 6.8-1.3 8.4-4.3-1.1-2.4-3.4-4.1-6.3-4.5z",
    opacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M109.613 272.068c3.515 1.563 7.845.86 10.682-2.003a9.49 9.49 0 0 0 1.733-10.717l-1.968-2.702a9.521 9.521 0 0 0-13.418.236 9.522 9.522 0 0 0 .235 13.418l2.736 1.768z",
    opacity: 0.7
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M109.761 271.902c3.322 1.511 7.432.852 10.148-1.94 2.715-2.792 3.197-6.908 1.603-10.234l-1.801-2.553c-3.629-3.457-9.355-3.335-12.786.198-3.457 3.628-3.432 9.329.197 12.786l2.639 1.743z",
    opacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M108.025 258.288c2.444-2.554 6.143-3.219 9.297-1.856.29.077.554.251.818.426.361.2.721.4 1.056.697.167.148.334.296.598.471 3.294 3.16 3.423 8.474.166 11.743-3.16 3.294-8.474 3.423-11.743.166a7.818 7.818 0 0 1-1.987-3.017l-.346-1.025c.026-.096-.045-.219-.045-.219-.564-2.532.187-5.333 2.186-7.386z",
    opacity: 0.7
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M108.025 258.288c2.445-2.554 6.143-3.22 9.298-1.857.538 2.629-.187 5.333-2.186 7.386-2.445 2.554-6.143 3.22-9.298 1.857-.564-2.532.187-5.334 2.186-7.386z",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M130.443 256.85c3.826-.404 7.224-3.178 8.25-7.077a9.49 9.49 0 0 0-3.858-10.147l-3.055-1.355a9.521 9.521 0 0 0-11.503 6.912 9.522 9.522 0 0 0 6.913 11.503l3.253.164z",
    opacity: 0.7
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M130.488 256.631c3.633-.352 6.863-2.978 7.819-6.754.955-3.775-.686-7.58-3.729-9.664l-2.836-1.311c-4.871-1.179-9.769 1.79-10.975 6.565-1.179 4.871 1.693 9.795 6.565 10.975l3.156.189z",
    opacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M122.178 245.71c.84-3.434 3.71-5.86 7.124-6.257.289-.077.605-.058.921-.039.412-.007.824-.014 1.262.075.219.045.438.09.754.109 4.433 1.09 7.202 5.628 6.016 10.087-1.09 4.433-5.628 7.202-10.087 6.015a7.793 7.793 0 0 1-3.229-1.619l-.813-.714c-.026-.097-.148-.167-.148-.167-1.754-1.911-2.505-4.713-1.8-7.49z",
    opacity: 0.7
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M122.178 245.709c.84-3.434 3.71-5.86 7.123-6.257 1.781 2.008 2.505 4.713 1.8 7.49-.84 3.434-3.71 5.86-7.123 6.257-1.755-1.911-2.505-4.713-1.8-7.49z",
    opacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M44.799 243.571c-1.563 3.515-.86 7.845 2.003 10.683a9.488 9.488 0 0 0 10.717 1.732l2.701-1.967a9.523 9.523 0 0 0-.235-13.419 9.522 9.522 0 0 0-13.418.236l-1.768 2.735z",
    opacity: 0.7
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M44.965 243.719c-1.511 3.322-.852 7.433 1.94 10.148s6.908 3.197 10.234 1.603l2.553-1.8c3.457-3.629 3.335-9.356-.198-12.787-3.629-3.457-9.33-3.431-12.786.197l-1.743 2.639z",
    opacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M58.578 241.984c2.555 2.444 3.22 6.142 1.857 9.297-.078.29-.252.554-.426.818-.2.36-.4.72-.697 1.055a4.846 4.846 0 0 0-.47.599c-3.161 3.294-8.476 3.423-11.744.166-3.294-3.16-3.423-8.475-.166-11.743a7.808 7.808 0 0 1 3.017-1.987l1.024-.347c.097.026.22-.045.22-.045 2.532-.563 5.333.187 7.385 2.187z",
    opacity: 0.7
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M58.579 241.984c2.554 2.444 3.22 6.142 1.857 9.297-2.629.538-5.334-.187-7.386-2.186-2.554-2.445-3.22-6.143-1.857-9.298 2.532-.563 5.334.187 7.386 2.187z",
    opacity: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M60.928 263.401c.404 3.826 3.178 7.224 7.076 8.25a9.488 9.488 0 0 0 10.147-3.858l1.356-3.055a9.52 9.52 0 0 0-6.913-11.502 9.52 9.52 0 0 0-11.503 6.912l-.163 3.253z",
    opacity: 0.7
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M61.146 263.447c.352 3.632 2.978 6.863 6.754 7.818 3.775.955 7.58-.685 9.664-3.728l1.31-2.836c1.18-4.872-1.789-9.77-6.564-10.975-4.87-1.18-9.795 1.693-10.975 6.564l-.189 3.157z",
    opacity: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M72.067 255.136c3.435.84 5.86 3.71 6.257 7.124.078.29.059.605.04.921.007.412.014.824-.076 1.263a4.86 4.86 0 0 0-.109.753c-1.09 4.433-5.627 7.202-10.086 6.016-4.433-1.09-7.202-5.628-6.016-10.087a7.807 7.807 0 0 1 1.62-3.229l.713-.812c.097-.026.168-.149.168-.149 1.91-1.754 4.712-2.505 7.49-1.8z",
    opacity: 0.7
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M72.068 255.136c3.434.84 5.86 3.71 6.257 7.124-2.008 1.78-4.712 2.505-7.49 1.8-3.434-.84-5.86-3.71-6.256-7.124 1.91-1.754 4.712-2.505 7.489-1.8z",
    opacity: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M44.13 234.76c-3.592-1.381-6.156-4.94-6.138-8.971a9.49 9.49 0 0 1 6.353-8.803l3.301-.519a9.522 9.522 0 0 1 9.322 9.655 9.523 9.523 0 0 1-9.654 9.322l-3.185-.684z",
    opacity: 0.7
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M44.056 234.487c-3.418-1.28-5.859-4.652-5.804-8.547.054-3.894 2.624-7.145 6.102-8.37l3.079-.532c5.01.121 8.973 4.257 8.902 9.181-.122 5.01-4.17 9.024-9.181 8.902l-3.098-.634z",
    opacity: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M54.996 226.139c.077-3.535-2.067-6.621-5.262-7.888-.26-.15-.57-.213-.88-.277-.395-.113-.792-.226-1.238-.253-.224-.014-.447-.027-.757-.09-4.564-.095-8.413 3.572-8.42 8.186-.096 4.564 3.571 8.413 8.185 8.421a7.814 7.814 0 0 0 3.539-.728l.97-.48c.05-.086.186-.123.186-.123 2.102-1.442 3.639-3.903 3.677-6.768z",
    opacity: 0.7
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M54.996 226.138c.078-3.535-2.067-6.62-5.261-7.887-2.24 1.478-3.64 3.903-3.677 6.768-.078 3.535 2.066 6.621 5.261 7.888 2.103-1.442 3.64-3.904 3.677-6.769z",
    opacity: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M83.3 178.073c1.8-3.4 5.6-5.5 9.7-5s7.2 3.6 8 7.4l.1 3.3c-.7 5.2-5.5 8.8-10.7 8.1-5.2-.7-8.8-5.5-8.1-10.7l1-3.1z",
    opacity: 0.7
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M83.5 178.074c1.7-3.3 5.3-5.3 9.2-4.7 3.9.5 6.8 3.4 7.6 7l.1 3.099c-.7 4.9-5.2 8.401-10.2 7.701-4.9-.701-8.4-5.201-7.7-10.201l1-2.899z",
    opacity: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M90.5 189.873c3.5.5 6.8-1.3 8.4-4.3.2-.3.3-.6.4-.8.2-.4.3-.8.4-1.2.1-.2.1-.5.1-.7.6-4.6-2.6-8.7-7.1-9.3-4.5-.6-8.7 2.6-9.3 7.1-.2 1.2-.1 2.5.3 3.6.1.3.2.7.4 1 0 .1.1.2.1.2 1.2 2.3 3.5 4.1 6.3 4.4z",
    opacity: 0.7
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M90.5 189.873c3.5.5 6.8-1.3 8.4-4.3-1.2-2.4-3.5-4.1-6.3-4.5-3.5-.5-6.8 1.3-8.4 4.3 1.2 2.4 3.5 4.2 6.3 4.5z",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(91.627 225.882) scale(91.5934)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(91.627 225.882) scale(91.5934)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(91.627 225.882) scale(78.2331)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(91.627 225.882) scale(73.812)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(91.627 225.882) scale(21.3939)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentrifugeTopEmpty);
export default __webpack_public_path__ + "static/media/centrifuge-top-empty.298fdab002202ff200763ee1de2b5ac6.svg";
export { ForwardRef as ReactComponent };